<template>
    <d-icon :key="name"
            :name="nameComputed"
            :width="width"
            :height="height"
            :original="original"
            :alt="altText"
            :color="color"
            :fill="fill"/>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';
import serverContextService from '@/core/serverContext.service';
import loggingService from '@/core/logging.service';

const props = defineProps({
    name: { type: String, required: true },
    height: { type: String, default: undefined },
    width: { type: String, default: undefined },
    original: { type: Boolean, default: false },
    alt: { type: String, default: undefined },
    title: { type: String, default: undefined },
    color: { type: String, default: undefined },
    fill: { type: [String, Boolean], default: undefined }
});

const nameComputed = computed(() => {
    const opremaPrefixedIcons = new Set(['logo', 'logo-half-eet', 'logo-half-top', 'lyn1', 'lyn2', 'lyn3', 'splash-new']);
    let name: string = props.name;
    if (serverContextService.isOprema && serverContextService.themeString && opremaPrefixedIcons.has(props.name)) {
        name = `${serverContextService.themeString}-${props.name}`;
    }
    return name;
});

const altText = computed((): string => {
    return props.alt || props.title || props.name;
});

const importIcon = (name: string) => {
    import(`@/project/icons/${name}.ts`).catch(e => loggingService.error(`icon fetch error: ${name}`));
};
importIcon(nameComputed.value);

watch(() => props.name, importIcon)
</script>
